import { useDocument, useList, useListWithSelection } from '@ztechapps/common.hook'
import type { Invoice } from '@ztechapps/totalmilk-payme.contract'
import { getInvoiceTotalAmount, invoiceListQuery } from '../list/graphql'
import type { useInvoiceFilters } from './useInvoiceFilters'

export const useInvoiceList = (invoiceFilters: ReturnType<typeof useInvoiceFilters>) => {
  const invoiceList = useList<Invoice>({
    query: invoiceListQuery,
    entity: 'getInvoiceList',
    filter: invoiceFilters.filter,
    sort: { date: -1 },
    limit: 100,
    listActionOptions: {
      defaultFilterCascade: false,
    },
  })

  const footerList = useDocument<any>({
    query: getInvoiceTotalAmount,
    entity: 'getInvoiceTotalAmount',
    filter: invoiceList.filter,
    options: { queryOptions: { fetchPolicy: 'cache-and-network' } },
  })

  const totalAmount: number = footerList.document ?? 0
  const totalInvoices: number = invoiceList?.data?.getInvoiceListMeta?.count ?? 0

  const listWithSelection = useListWithSelection(invoiceList.list)

  return {
    listWithSelection,
    invoiceList,
    totalAmount,
    totalInvoices,
  }
}
